import { Image, Text, View } from "@react-pdf/renderer";
import { borderColor, styles } from "./styles";
import { SinglePdfHeaderType } from "../GenericPdf/constant";
import BatchSummaryTableFooter from "./BatchSummaryTableFooter";
import BatchSummaryInvoiceTableHeader from "./BatchSummaryInvoiceTableHeader";
import BatchSummaryInvoiceTableRow from "./BatchSummaryInvoiceTableRow";
import BatchSummaryTableHeader from "./BatchSummaryTableHeader";
import BatchSummaryTableRow from "./BatchSummaryTableRow";

let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
let blobToken = process.env.REACT_APP_BLOB_TOEKN;


type AppProps = {
  downloadRevenuesData: any;
  tableHeaders: SinglePdfHeaderType[];
  currencySign: string | undefined;
  finalGstSummaryTableHeader: SinglePdfHeaderType[];
  currencyShortForm: string | undefined;
  isGstSummary: boolean;
};

const BatchSummaryItemDetails = ({
  downloadRevenuesData,
  tableHeaders,
  currencySign,
  currencyShortForm,
  isGstSummary,
  finalGstSummaryTableHeader
}: AppProps) => {
  return (
    <View>
      <View style={styles.tableContainer}>
        <BatchSummaryInvoiceTableHeader
          tableHeaders={tableHeaders}
        />
        <BatchSummaryInvoiceTableRow
          items={downloadRevenuesData?.item_details}
          tableHeaders={tableHeaders}
        />
        <BatchSummaryTableFooter
          items={downloadRevenuesData}
          isGstSummary={isGstSummary}
          currencySign={currencySign}
          currencyShortForm={currencyShortForm}
          finalGstSummaryTableHeader={finalGstSummaryTableHeader}
          signature={
            downloadRevenuesData?.primary_details?.business_address_details
              ?.signature
          }
        />
      </View>

      <View>
        <View style={{ ...styles.row, width: "100%", marginTop: 10 }}>
          <View style={[styles.gstTableContainer, { width: "70%" }]}>
            <View>
              <BatchSummaryTableHeader tableHeaders={finalGstSummaryTableHeader} />
              <BatchSummaryTableRow
                items={downloadRevenuesData?.gst_summary_details}
                tableHeaders={finalGstSummaryTableHeader}
              />
            </View>

          </View>

          <View
            style={{
              justifyContent: "space-between",
              width: "30%",
              height: "120px",
              // borderLeft: `1px solid ${borderColor}`,
              borderRight: `1px solid ${borderColor}`,
              borderTop: `1px solid ${borderColor}`,
            }}
          >
            {downloadRevenuesData?.primary_details?.business_address_details
              ?.signature?.file_url ? (
              <View style={{ ...styles.tableFooter }}>
                <Image
                  src={`${blobBaseUrl}${downloadRevenuesData?.primary_details?.business_address_details
                    ?.signature?.file_url}?${blobToken}`}
                />
              </View>
            ) : (
              <Text style={{ ...styles.tableFooter }}></Text>
            )}
            <View>
              <Text
                style={{
                  ...styles.for,
                  borderTop: `1px solid ${borderColor}`,
                  paddingTop: "2px",
                  paddingLeft: "2px",
                  flexWrap: "wrap",
                  textAlign: "center",
                }}
              >
                For {downloadRevenuesData?.primary_details?.bill_from?.trade_name}
              </Text>
            </View>
          </View>
        </View>

        {downloadRevenuesData?.payment_details?.length ? (
          <View style={{ ...styles.row, borderRight: `1px solid ${borderColor}`, borderLeft: `1px solid ${borderColor}` }}>
            <View
              style={{
                ...styles.flexCenter,
                marginTop: "5px",
                padding: "5px",
                flexWrap: "wrap",
              }}
              break
            >
              <Text style={{ ...styles.sub_header }}>Note : </Text>
              <Text style={{ ...styles.text }}>
                {downloadRevenuesData?.payment_details[0]?.narration}
              </Text>
            </View>
          </View>
        ) : null}
      </View>
    </View>
  );
};

export default BatchSummaryItemDetails;
